var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('div',[_c('nuxt-child',{key:_vm.$route.path,attrs:{"company":_vm.company},on:{"updated-schedule":_vm.updatedSchedule}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }